import {Color} from '@benchling/nucleus-ui';
import React from 'react';
import {BaseEdge, EdgeProps, getBezierPath} from 'reactflow';

export enum LineStyle {
  SOLID = 'SOLID',
  DASHED = 'DASHED',
}

interface BaseEdgeRendererData {
  color?: string;
  lineStyle?: LineStyle;
}

const DEFAULT_EDGE_OPTIONS: BaseEdgeRendererData = {
  color: Color.GRAY_400,
  lineStyle: LineStyle.SOLID,
};

/**
 * This is a simple bezier edge renderer which can be used for many simple edge types.
 * It renders a bezier curve between two nodes with a default style.
 */
export default function BaseEdgeRenderer({
  data = DEFAULT_EDGE_OPTIONS,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  selected,
}: EdgeProps<BaseEdgeRendererData>): JSX.Element {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const edgePathStyle = {
    stroke: selected ? Color.BLUE_450 : (data.color ?? DEFAULT_EDGE_OPTIONS.color),
    strokeWidth: '1.5px',
    strokeDasharray: data.lineStyle === LineStyle.DASHED ? '2 3' : undefined,
  };

  return <BaseEdge path={edgePath} markerEnd={markerEnd} style={edgePathStyle} />;
}
